namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmVault extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmVaultReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmVaultObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmVaultObj());
            this.detailObj.createBase({
                contentName: "detailAdmVault",
                contentCaption: "jres:33000567", //RC 33000567 : Trezor
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmVault", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmVaultObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmVaultReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_vau) ? this.data.ixs_vau.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmVaultSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmVault.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVault", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmVault.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_vau");
            this.MakeField("poradi");
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeSelectField("typ_vau", Gordic.Prefabs.Select.gincvau(), {
                serverFilters: {
                    typ_vau: [ 0, 10, 20, 30, 40 ]
                },
                model: "model.typ_vau=value.typ_vau",
                change: (ev, ctx) => {
                    var nazevAzureField = this.cnt.findFields("nazev_azure");
                    var ixsOapField = this.cnt.findFields("ixs_oap");
                    nazevAzureField.gfield("option", "validators", [])
                    ixsOapField.gfield("option", "validators", [])
                    this.HideField("nazev_azure");
                    this.HideField("ixs_oap");
                    this.HideField("path");
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value.typ_vau == 10) {
                                this.ShowField("path");
                            } else if (ctx.value.typ_vau == 30) {
                                this.ShowField("nazev_azure");
                                this.ShowField("ixs_oap");
                                nazevAzureField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                nazevAzureField.gfield("option", "flag", "required")
                                ixsOapField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                ixsOapField.gfield("option", "flag", "required")
                            }
                        }
                    }
                }
            })
            // typ_vau = 30
            this.MakeField("nazev_azure");
            this.MakeSelectField("ixs_oap", Gordic.Prefabs.Select.ginsoap(), { model: "model.ixs_oap=value.ixs_oap" })
            // typ_vau = 10
            this.MakeField("path", {
                tag: {
                    text: "jres:33000985", //RC 33000985 : Složka obsahuje soubor ginis_secrets.json, pokud není vyplněno bere se automatickz složka s instalací GINIS.
                    state: "info"
                },
                validators: [
                    this.getValidatorSlozka()
                ]
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private getValidatorSlozka(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000986", //RC 33000986 : Cesta ke složce není validní!
                validate: (val, ev) => {
                    if (val == null || val == undefined || val == "")
                        return true;
                    if (val.slice(-1) == "\\")
                        return true;
                    return false;
                }
            })
        }
    }
}